import React from "react";
import "./Button.css";

const Button = ({
  children,
  startIcon,
  endIcon,
  onClick,
  type = "button",
  variant = "primary",
  size = "md",
  fullWidth = false,
  isLoading = false,
  disabled = false,
  className = "",
  ...rest
}) => {
  const base = "wg-btn";

  const classes = [
    base,
    `${base}--${variant}`,
    `${base}--${size}`,
    fullWidth && `${base}--full-width`,
    (disabled || isLoading) && `${base}--disabled`,
    isLoading && `${base}--loading`,
    className,
  ]
    .filter(Boolean)
    .join(" ");

  const isDisabled = disabled || isLoading;

  return (
    <button
      type={type}
      className={classes}
      onClick={isDisabled ? undefined : onClick}
      disabled={isDisabled}
      {...rest}
    >
      {isLoading && (
        <span className="wg-btn__spinner" aria-hidden="true" />
      )}

      {startIcon && !isLoading && (
        <span className="wg-btn__icon wg-btn__icon--start">
          {startIcon}
        </span>
      )}

      <span className="wg-btn__label">{children}</span>

      {endIcon && !isLoading && (
        <span className="wg-btn__icon wg-btn__icon--end">
          {endIcon}
        </span>
      )}
    </button>
  );
};

export default Button;